import { getDatabase, ref, runTransaction } from 'firebase/database';

/** Enables the intro for a new account without overwriting state recorded by the apps. */
export const initializeOnboarding = async (userId: string): Promise<void> => {
  await runTransaction(
    ref(getDatabase(), `user-appstate/${userId}/onboarding/isAppIntroEnabled`),
    (current) => (current === null ? true : undefined),
    { applyLocally: false }
  );
};
